var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopySvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_17418",
    "data-name": "Group 17418",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14.226,
    height: 16.483,
    viewBox: "0 0 14.226 16.483",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16726",
    "data-name": "Rectangle 16726",
    width: 14.226,
    height: 16.483,
    fill: "#5e829f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17417",
    "data-name": "Group 17417",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41593",
    "data-name": "Path 41593",
    d: "M53.873,49.5q0,2.562,0,5.124a1.51,1.51,0,0,1-1.6,1.608q-4.018,0-8.036,0a1.508,1.508,0,0,1-1.6-1.595q0-5.15,0-10.3a1.5,1.5,0,0,1,1.583-1.584q4.036,0,8.071,0a1.5,1.5,0,0,1,1.578,1.589q0,2.58,0,5.159m-1.5-.017q0-2.2,0-4.4a.756.756,0,0,0-.839-.833H44.987a.759.759,0,0,0-.845.845q0,4.4,0,8.791a.759.759,0,0,0,.857.849h6.509a.762.762,0,0,0,.863-.861q0-2.193,0-4.387",
    transform: "translate(-39.647 -39.752)",
    fill: "#5e829f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41594",
    "data-name": "Path 41594",
    d: "M0,6.328C0,4.737,0,3.146,0,1.555A1.481,1.481,0,0,1,1.147.049,1.865,1.865,0,0,1,1.581,0Q5.617,0,9.652,0a.762.762,0,0,1,.818.637.749.749,0,0,1-.746.864c-.053,0-.105,0-.158,0H2.355a.768.768,0,0,0-.861.867q0,4.387,0,8.774a.753.753,0,0,1-.654.835.745.745,0,0,1-.832-.649C0,11.248,0,11.166,0,11.084Q0,8.706,0,6.328",
    transform: "translate(0 0.001)",
    fill: "#5e829f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopySvg);
export default __webpack_public_path__ + "static/media/copySvg.e79d83911efd4174adee3f5b6b06dcc7.svg";
export { ForwardRef as ReactComponent };